import { useState } from "react";
import { Alert, Button, Input, Modal, Select } from "@/components/common";
import { useInviteUser, useRoles } from "@/hooks/useAdmin";

interface InviteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function InviteUserModal({ isOpen, onClose }: InviteUserModalProps) {
  const { data: roles = [] } = useRoles();
  const inviteUser = useInviteUser();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [roleId, setRoleId] = useState("");

  function handleClose() {
    setEmail("");
    setFirstName("");
    setLastName("");
    setRoleId("");
    inviteUser.reset();
    onClose();
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    inviteUser.mutate(
      { email, firstName, lastName, roleId },
      { onSuccess: handleClose },
    );
  }

  const roleOptions = roles.map((r) => ({
    value: r.id,
    label: r.name,
  }));

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Zaproś agenta">
      <form onSubmit={handleSubmit} className="space-y-4">
        {inviteUser.isError && (
          <Alert variant="error">
            {(inviteUser.error as { message?: string })?.message ??
              "Nie udało się wysłać zaproszenia"}
          </Alert>
        )}

        <Input
          label="Adres e-mail"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          required
          placeholder="jan.kowalski@adara.pl"
        />

        <div className="grid gap-4 sm:grid-cols-2">
          <Input
            label="Imię"
            value={firstName}
            onChange={(e) => {
              setFirstName(e.target.value);
            }}
            required
          />
          <Input
            label="Nazwisko"
            value={lastName}
            onChange={(e) => {
              setLastName(e.target.value);
            }}
            required
          />
        </div>

        <Select
          label="Rola"
          options={roleOptions}
          value={roleId}
          onChange={setRoleId}
          placeholder="Wybierz rolę..."
        />

        <div className="flex justify-end gap-3 border-t border-edge-soft pt-4">
          <Button variant="ghost" type="button" onClick={handleClose}>
            Anuluj
          </Button>
          <Button
            type="submit"
            isLoading={inviteUser.isPending}
            disabled={!email || !firstName || !lastName || !roleId}
          >
            Wyślij zaproszenie
          </Button>
        </div>
      </form>
    </Modal>
  );
}
